import type {ReactElement} from 'react';
import React from 'react';
import {BaseBlackAndWhiteOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-black-and-white-option';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromEffectsActiveItem} from '@Hooks/poster-editor/useGetKeyFromEffectsOfActiveItem';

export function ItemBlackAndWhiteOption(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const blackAndWhite = useGetKeyFromEffectsActiveItem('blackAndWhite');

  if (!activeItem) {
    throw new Error('Active item does not exist in item black and white option');
  }

  if ((activeItem && !('effects' in activeItem)) || blackAndWhite === undefined) {
    throw new Error(`Item doesn't have effects property`);
  }

  const onToggleHandler = (): void => {
    void activeItem.updateFromObject({
      effects: {
        blackAndWhite: !blackAndWhite,
      },
    });
  };

  return <BaseBlackAndWhiteOption isChecked={blackAndWhite} onToggleOption={onToggleHandler} />;
}
